import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter, ViewContainerRef, TemplateRef, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { SupervisionError, Supervision, Site } from 'solar-bo';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation, NgxGalleryComponent } from 'ngx-gallery'; 
import { MapSupervisionHelper } from '@solar/ol';
import { SolarService } from '../../services/solarservice.service';
import { SolarBaseComponent } from '@solar/solar/solar-base';

import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Subscription, fromEvent } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-imageslider',
  templateUrl: './imageslider.component.html',
  styleUrls: ['./imageslider.component.scss']
})
export class ImageSliderComponent extends SolarBaseComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {


  @Input() load_type: string = "FLIGHT";//OTHER TYPES "ISSUES"
  @Input() flights: string[] = [];

  _issue: SupervisionError;
  @Input() set issue(value: SupervisionError) {
    this._issue = value;
    this.loadImagesByIssue(value);
  }
  get issue(): SupervisionError {
    return this._issue;
  }
  @Input() issueList: SupervisionError[];
  _selectedIndex: number = 0;
  galleryOptions: NgxGalleryOptions[];
  @Input() galleryImagesStore: NgxGalleryImage[] = [];

  /**
   * event emitted when right click on thumb image
   */
  @Output() onThumbRightClick = new EventEmitter();

  @ViewChild("gallery") gallery: NgxGalleryComponent;

  //context menu vars
  ctx_MouseEventSubscription: Subscription;
  @ViewChild('ctxMenu') ctxMenu: TemplateRef<any>;
  overlayRef: OverlayRef | null;

  constructor(public solarService: SolarService,
    public overlay: Overlay,
    public viewContainerRef: ViewContainerRef) {
    super();
  }

  ngOnInit() {
    this.configureGalleryOptions();
    if (this.load_type == "FLIGHT") {

    }
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log("IssuecanvasComponent ngOnChanges " ,changes);
    let typeChange = changes['imageUrlList'];
    if (typeChange && typeChange.currentValue != null) {
      if (this.load_type == "ISSUES") {
        //this.configureImagesByIssueList(typeChange.currentValue);
      }
    }
  }

  ngAfterViewInit() {
    //console.log("ngAfterViewInit this.gallery: " + this.gallery);
  }

  ngOnDestroy(){
    this.ctx_MouseEventSubscription && this.ctx_MouseEventSubscription.unsubscribe();
  }

  onImagesReady(event: any) {
    //console.log("onImagesReady");
    //this.gallery.show(this._selectedIndex);
    //let intIndex = this.getImageIndexByIssue(this.issue,this.galleryImages);
    //this.gallery.show(intIndex);
  }




  showHideByReload: boolean = true;
  private loadImagesByIssue(issueSelected: SupervisionError) {
    if (!this._issue) {
      return;
    }

    let flightLoaded = this.flights.find(item => item == issueSelected.flight.id);
    if (!flightLoaded) {
      this.showHideByReload = false;
      this.flights.push(issueSelected.flight.id);
      this.loadFlightImages(issueSelected);

    }
    else {
      //find image index
      this.showHideByReload = true;
      this.selectImageByIssue(issueSelected);
    }
  }

  private selectImageByIssue(issueSelected: SupervisionError) {
    //let imgName=issueSelected.image.name;
    //let url = this.flightimageBigUrl(imgName, issueSelected.supervision.site.id, issueSelected.supervision.id, issueSelected.flight.id);
    //let index = this.galleryImages.findIndex(item => item.label == imgName);
    /*     let index = this.getImageIndexByIssue(issueSelected,this.galleryImages_back);
        if (index > -1) {
          this._selectedIndex=index;
    
          //this.gallery.show(index);
        }   */
    this.loadCarousselData(issueSelected);
  }


  private loadFlightImages(issueSelected: SupervisionError) {
    this.loading = true;
    this.solarService.flightGetImagesCaroussel(issueSelected.flight.id)
      .subscribe(
        res_list => this.loadFlightImagesHandleresult(issueSelected, res_list)
        , err => this.handleError(err)
      );
  }

  private async loadFlightImagesHandleresult(issueSelected: SupervisionError, newlist: any[]) {
    //console.log("Image count ", newlist);
    this.showHideByReload = true;
    let promise = this.configureImagesByFlight(issueSelected, newlist);
    promise.then(result => this.selectImageByIssue(issueSelected));
    this.loading = false;
  }

  private async configureImagesByFlight(issueSelected: SupervisionError, list: any[]) {
    if (!list || list.length == 0) {
      return;
    }

    let gal: NgxGalleryImage[] = [];
    for (let img of list) {
      let url = this.flightimageBigUrl(img.name, issueSelected.supervision.site.id, issueSelected.supervision.id, issueSelected.flight.id);
      let urlThumb = this.flightImageThumbUrl(img.name, issueSelected.supervision.site.id, issueSelected.supervision.id, issueSelected.flight.id);
      let obj = {
        id:img.id,
        small: url,
        medium: url,
        big: url
        , description: img.name
        , label: img.name
        , tag: { flight: issueSelected.flight, image: img }
      };
      gal.push(obj);
    }
    //setTimeout(() => {console.log("step 1 timer ends")}, 5000, console.log("step 1 timer"));

    //this.galleryImages =gal.slice(0,20);// this.galleryImages.concat(gal);    
    this.galleryImagesStore = this.galleryImagesStore.concat(gal);
    this.loadCarousselData(issueSelected);
    this.showHideByReload = true;
    return true;
  }

  private car_length: number = 20;
  private loadCarousselData(issueSelected: SupervisionError) {

    let existIndex = this.getImageIndexByIssue(issueSelected, this.gallery.galleryImage);//index in sliced array
    if (existIndex > -1 && existIndex != this.gallery.selectedIndex) {
      //existe en el actual     
      this.moveToCenter(existIndex);
      return;
    }
    else if (existIndex == this.gallery.selectedIndex) {
      return;
    }

    let index = this.getImageIndexByIssue(issueSelected, this.galleryImagesStore);
    if (index > -1) {
      this._selectedIndex = index;
      let length = this.galleryImagesStore.length;
      //left 
      let maxL = index - this.car_length;
      if (maxL < 0) {
        maxL = 0;
      }
      //right 
      let maxR = length - index;
      if (maxR > this.car_length) {
        maxR = index + this.car_length;
      }
      else {
        maxR = index + maxR;
      }

      let newGallery = this.galleryImagesStore.slice(maxL, maxR);// this.galleryImages.concat(gal); 
      let intIndex = this.getImageIndexByIssue(issueSelected, newGallery);//index in sliced array
      this.gallery.loadGalleryAndIndex(intIndex, newGallery);
      this.moveToCenter(intIndex);
    }
  }

  private moveToCenter(indexToBeSelected: number) {

    let lastIndex = this.gallery.selectedIndex;
    let moves = lastIndex - indexToBeSelected;
    this.gallery.show(indexToBeSelected);
    let leftIndex = this.gallery.getThumbnailsLeftIndex()
    //console.log("lastIndex: %o moves: %o indexToBeSelected: %o leftindex:%o",lastIndex,moves,indexToBeSelected,leftIndex)

    if ((indexToBeSelected - leftIndex) > 3) {
      moves = -(indexToBeSelected - leftIndex - 3);
    } else if ((indexToBeSelected - leftIndex) < 3) {
      moves = +((leftIndex - indexToBeSelected) + 3);
    }

    for (let mov = 0; mov < Math.abs(moves); mov++) {

      //this.gallery.show(existIndex);
      if (moves < 0) {
        if (this.gallery.canMoveThumbnailsRight()) {
          this.gallery.moveThumbnailsRight();
        }
      } else {
        if (this.gallery.canMoveThumbnailsLeft()) {
          this.gallery.moveThumbnailsLeft();
        }
      }
    }
  }

  private getImageIndexByIssue(issueSelected: SupervisionError, list: any[]) {
    if (!list) {
      return -1;
    }
    let imgName = issueSelected.image.name;
    let url = this.flightimageBigUrl(imgName, issueSelected.supervision.site.id, issueSelected.supervision.id, issueSelected.flight.id);
    let index = list.findIndex(item => item.big === url);
    //console.log("getImageIndexByIssue internal index:" + index);
    return index;
  }



  private configureGalleryOptions() {
    this.galleryOptions = [
      {
        width: '100%',
        height: '100px',
        thumbnailsColumns: 7,
        thumbnailsShowLabels: true,
        lazyLoading: true,
        preview: true,
        image: false,
        imageAnimation: NgxGalleryAnimation.Slide
        , imageDescription: true
        , thumbnailsSwipe: true
        , previewCloseOnEsc: true
      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '100px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false
      }
    ];
  }

  flightimageBigUrl(image_name: string, id_site: string, id_supervision: string, id_flight: string): string {
    return MapSupervisionHelper.issueUrlImgByFullFields(image_name, id_site, id_supervision, id_flight);
  }
  flightImageThumbUrl(image_name: string, id_site: string, id_supervision: string, id_flight: string): string {
    return MapSupervisionHelper.FlightImageThumbUrlByFullFields(image_name, id_site, id_supervision, id_flight);
  }

  /**
   * helper to get the images list
   */
  getImagesList() {
    if (this.gallery) {
      return this.gallery.images;
    }

    return [];
  }
  /**
   * get the image object by index
   * @param index 
   */
  getImage(index: number) {
    let lst = this.getImagesList();

    if (index > -1 && index < lst.length) {
      return lst[index];
    }

    return null;
  }

  actionTest: any = { actions: [{ description: 'New Issue from image', action: this.ctx_test }, { description: 'Remove image', action: this.ctx_test }] }
  ctx_test(event, item) {
    console.log(event, item);
  }

  thumbOnRightClick($event) {
    let index: number = $event.index;
    let item: any = {index:index, actions: []};
    item.actions.push( { description: 'New Issue from image ',action: this.thumbOnRightClick_handler.bind(this) });
    //item.actions.push( { description: 'Remove image'        ,action: this.ctx_test });
    this.ctx_open($event.event, item);
    return false;//to avoid show context
  }

  thumbOnRightClick_handler($event, item) {
    console.log($event, item);
    let index: number = item.index;
    this.ctx_close();
    this.onThumbRightClick.emit(index);    
    return false;//to avoid show context
  }


  ctx_open({ x, y }: MouseEvent, item) {
    try {
      this.ctx_close();
      const positionStrategy = this.overlay.position()
        .flexibleConnectedTo({ x, y })
        .withPositions([
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          }
        ]);

      this.overlayRef = this.overlay.create({
        positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.close()
      });

      this.overlayRef.attach(new TemplatePortal(this.ctxMenu, this.viewContainerRef, {
        $implicit: item
      }));

      this.ctx_MouseEventSubscription = fromEvent<MouseEvent>(document, 'click')
        .pipe(
          filter(event => {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }),
          take(1)
        ).subscribe(() => this.ctx_close())
    }
    catch (error) {
      console.error(error);
    }
  }

  ctx_close() {
    this.ctx_MouseEventSubscription && this.ctx_MouseEventSubscription.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }



}
